import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/** Badge colour variants that have dedicated styles. */
export type BadgeColor = 'primary' | 'secondary' | 'critical';

@Component({
  selector: 'twc-badge',
  imports: [CommonModule],
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeComponent {
  @Input({ required: true }) count: number;
  @Input() color = 'primary';
}
